import { TrendingUp } from "lucide-react";
import { StatCard, ProgressBar } from "./parts";

// Revenue forecast cards + per-tier breakdown for the annual quotas.
export const RevenuePanels = ({ revenue, counts }) => (
  <>
    <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="quotas-revenue-cards">
      <StatCard
        label="Receita prevista"
        value={`${revenue.forecast_eur.toFixed(2)} €`}
        sub={`${(counts.paid || 0) + (counts.pending || 0)} sócios a pagar`}
        tone="primary" testid="stat-forecast"
      />
      <StatCard
        label="Já recebido"
        value={`${revenue.collected_eur.toFixed(2)} €`}
        sub={`${counts.paid || 0} sócios pagaram`}
        tone="emerald" testid="stat-collected"
      />
      <StatCard
        label="Por receber"
        value={`${revenue.pending_eur.toFixed(2)} €`}
        sub={`${counts.pending || 0} sócios pendentes`}
        tone="amber" testid="stat-pending"
      />
      <StatCard
        label="Cobertura"
        value={`${revenue.coverage_pct.toFixed(1)} %`}
        sub={<ProgressBar pct={revenue.coverage_pct} />}
        tone="accent" testid="stat-coverage"
      />
    </div>

    <div className="mt-4 bg-white border border-[hsl(var(--border))] p-5" data-testid="quotas-tier-breakdown">
      <div className="flex items-center gap-2 mb-3">
        <TrendingUp className="h-4 w-4 text-[hsl(var(--accent))]" />
        <span className="overline">Por nível</span>
      </div>
      <div className="grid sm:grid-cols-3 lg:grid-cols-5 gap-4 text-sm">
        {[
          { key: "aderente", label: "Aderente" },
          { key: "efetivo", label: "Efetivo" },
          { key: "benemerito", label: "Benemérito" },
          { key: "institucional", label: "Institucional" },
          { key: "honorario", label: "Honorário" },
        ].map(({ key, label }) => {
          const t = revenue.by_tier?.[key] || {};
          return (
            <div key={key} className="border border-[hsl(var(--border))]/60 p-4">
              <div className="text-xs uppercase tracking-[0.16em] text-[hsl(var(--muted-foreground))]">{label}</div>
              <div className="display-heading text-2xl mt-1">{t.count || 0}</div>
              <div className="mt-2 text-xs text-[hsl(var(--muted-foreground))]">
                {key === "honorario" ? "Isentos" :
                  `${t.paid_count || 0} pagas · ${t.pending_count || 0} pendentes · ${(t.forecast_eur || 0).toFixed(0)} €`}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </>
);
